import api from './api'

export default {
  async login(email, password) {
    return api.post('/admin-app/login', { email, password })
  },
  async getProfile() {
    return api.get('/admin-app/profile')
  },
  async logout() {
    // Admin logout is client-side only (clear token)
    return Promise.resolve({ data: { success: true } })
  },
}
